import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueSimpleAlert from "vue-simple-alert";
import { misMixins } from "./mixins/misMixins.js";

Vue.config.productionTip = false;
//axios.defaults.baseURL = "https://localhost:44382/";
//Vue.prototype.$httpConfiguracion = "url.myModuloConfiguracion.rutahttp";

async function loadConfig() {
  console.log("Iniciando carga .... espere por favor");
  let url = await misMixins.methods.cargarConfig();
  console.log(url);
  axios.defaults.baseURL = url.myApiPrincipal.rutahttp;
  console.log("Finalizando proceso de carga....");
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");

  // ...
  const options = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
    styles: [
      "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
      "https://unpkg.com/kidlat-css/css/kidlat.css",
    ],
  };
  Vue.use(VueSimpleAlert);
}
loadConfig();
